export enum UserAction {
  ENCOUNTER_CLOSED = "ENCOUNTER_CLOSED",
  ENCOUNTER_HANDED_OFF = "ENCOUNTER_HANDED_OFF",
  ENCOUNTER_PAUSED = "ENCOUNTER_PAUSED",
  PATIENT_TAB_CLOSED = "PATIENT_TAB_CLOSED",
}

export interface ActionHistoryEntry {
  id: string;
  action: UserAction;
  timestamp: string;
  context: {
    encounterId?: string;
    patientId: string;
  };
}

export interface ActionHistoryContext {
  encounterId?: string;
  patientId: string;
}
